import axios from 'axios';
import { API_URL } from '../../../utils/constants';
import { toast } from "react-toastify";

export const getAzureSQLDBApi = async (param, provider) => {
  try {
    param.params.type = 2;
    const token = localStorage.getItem('api_token');
    const endpoint = provider === "gcp" ? "gcp/cloud-sql" : "sql-data";
    const response = await axios({
      method: 'GET',
      url: `${API_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "", // Include token if available
      },

      data: param
    });
    return response
  } catch (e) {
    return [];
  }
};

export const getAzurePostgreSQLDBApi = async (param, provider) => {
  try {
    param.params.type = 2;
    const token = localStorage.getItem('api_token');
    const endpoint = provider === "gcp" ? "gcp/cloud-sql" : "fetch-postgresql-data-from-db";
    const response = await axios({
      method: 'GET',
      url: `${API_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "", // Include token if available
      },

      data: param
    });
    return response
  } catch (e) {
    return [];
  }
};

export const getAzureMySQLDBApi = async (param, provider) => {
  try {
    param.params.type = 2;
    const token = localStorage.getItem('api_token');
    const endpoint = provider === "gcp" ? "gcp/cloud-sql" : "fetch-mysql-data-from-db";
    const response = await axios({
      method: 'GET',
      url: `${API_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "", // Include token if available
      },

      data: param
    });
    return response
  } catch (e) {
    return [];
  }
};

export const getGCPCloudSQLApi = async (param) => {
  try {
    const token = localStorage.getItem('api_token');
    const response = await axios({
      method: 'GET',
      url: `${API_URL}gcp/cloud-sql`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "",
      },
      data: param
    });
    return response;
  } catch (e) {
    return [];
  }
};

export const getAvailableDatabaseTypesApi = async () => {
  try {
    const token = localStorage.getItem('api_token');
    console.log("Calling available-database-types API with token:", token ? "present" : "missing");

    const response = await axios({
      method: 'GET',
      url: `${API_URL}available-database-types`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "",
      },
    });

    console.log("Raw API response:", response);
    return response;
  } catch (e) {
    console.error("Error fetching available database types:", e);
    console.error("Error response:", e.response);
    return { data: { data: { available_types: [] } } };
  }
};

export const getSubscriptionsListApi = async () => {
  try {
    const token = localStorage.getItem('api_token');
    const response = await axios({
      method: 'GET',
      url: `${API_URL}subscriptions-list`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": token ? `Bearer ${token}` : "",
      },
    });
    return response;
  } catch (e) {
    console.error("Error fetching subscriptions:", e);
    return { data: { data: { subscriptions: [] } } };
  }
};

